import mergeShopData from './mergeShopData';
import { IExchangeState } from 'types/exchange';

export default function fetchAvailableSuccess(state: IExchangeState, payload: { id: number, items: any[] }) {
  return {
    ...state,
    isFetchingAvailable: false,
    shops: mergeShopData(state, payload),
  };
}